import MuiCheckbox, {
  CheckboxProps as MuiCheckboxProps,
} from "@mui/material/Checkbox";

import { TestProps } from "shared/types";

import Typography from "features/components/Typography";

export interface CheckboxProps
  extends Omit<MuiCheckboxProps, "onChange">, TestProps {
  label?: string | React.ReactNode;
  onChange?: (checked: boolean) => void;
  onClick?: (event: React.MouseEvent) => void;
}

const Checkbox = ({
  label,
  onChange,
  testId,
  size = "medium",
  onClick,
  className,
  ...otherProps
}: CheckboxProps) => (
  <label
    className="MuiCheckbox-wrapper flex items-center space-x-2 cursor-pointer"
    onClick={onClick}
  >
    <MuiCheckbox
      {...otherProps}
      size={size}
      onChange={(e) => onChange?.(e.target.checked)}
      data-testid={testId}
    />
    {typeof label === "string" ? (
      <Typography
        variant={size === "small" ? "body3" : "body2"}
        className={className}
      >
        {label}
      </Typography>
    ) : (
      label
    )}
  </label>
);

export default Checkbox;
